import { useEffect, useState } from "react";
import { Box, Modal } from "@mui/material";
import { TermsAndConditionsDO } from "./TermsAndConditionsDO";

const getModalStyle = (isMobile: boolean) => ({
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: isMobile ? "98%" : "80%",
  maxWidth: 1200,
  maxHeight: isMobile ? "90vh" : "80vh",
  overflowY: "auto" as const,
  overflowX: "hidden" as const,
  bgcolor: "#fff",
  border: "1px solid #898989",
  boxShadow: 24,
  borderRadius: 4,
  p: isMobile ? "1rem 0.75rem" : "2rem 4rem",
});

const MOBILE_BREAKPOINT = 768;

export interface LegalModalProps {
  /** Modo controlado: el padre controla open/onClose y no se muestra el botón fijo (el botón va en el footer). */
  open?: boolean;
  onClose?: () => void;
}

export function LegalModal({ open: controlledOpen, onClose }: LegalModalProps = {}) {
  const [internalOpen, setInternalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const isControlled = controlledOpen !== undefined && onClose !== undefined;
  const openModal = isControlled ? controlledOpen : internalOpen;
  const handleClose = isControlled ? (onClose ?? (() => {})) : () => setInternalOpen(false);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const set = () => setIsMobile(mq.matches);
    set();
    mq.addEventListener("change", set);
    return () => mq.removeEventListener("change", set);
  }, []);

  return (
    <>
      {!isControlled && (
        <button
          type="button"
          onClick={() => setInternalOpen(true)}
          className="inline-flex bg-[#3b3b3b] text-white items-center justify-center whitespace-nowrap rounded-xl md:rounded-2xl text-xs md:text-sm font-medium transition-colors hover:bg-[#2d2d2d] px-3 py-1 md:px-5 fixed right-3 top-3 md:right-8 md:top-8 z-10"
        >
          Legales
        </button>
      )}
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="Términos y condiciones"
        aria-describedby="Términos y condiciones y políticas de privacidad"
      >
        <Box sx={getModalStyle(isMobile)} className="custom-scrollbar-light">
          <TermsAndConditionsDO onClose={handleClose} />
        </Box>
      </Modal>
    </>
  );
}
